import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseVanillaFormFields } from '@/pages/instruments/new-instrument/fields/base-vanilla.fields'
import { ContractTypeField } from '@/pages/instruments/new-instrument/form-fields/ContractTypeFormField'
import { SideField } from '@/pages/instruments/new-instrument/form-fields/SideFormField'

export interface VanillaFormFieldsProps {}

export const VanillaFormFields: React.FC<VanillaFormFieldsProps> = ({}) => {
  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseVanillaFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <ContractTypeField />
          <SideField />
        </FormFieldRow>
      </div>
    </div>
  )
}
